export const neighbourhoodData = {
    "All Neighboorhoods" :[
            {"id": "Sumac", "label": "Sumac", "value": 0.0, "color": "hsl(20, 79%, 83%)"}, {"id": "Styrax", "label": "Styrax", "value": 1.1, "color": "hsl(199, 73%, 83%)"}, {"id": "Tree of Heaven", "label": "Tree of Heaven", "value": 0.0, "color": "hsl(41, 85%, 83%)"}, {"id": "Giant Sequoia", "label": "Giant Sequoia", "value": 0.1, "color": "hsl(158, 76%, 86%)"}, {"id": "Golden Chain", "label": "Golden Chain", "value": 0.1, "color": "hsl(42, 100%, 85%)"}, {"id": "Wingnut", "label": "Wingnut", "value": 0.0, "color": "hsl(142, 42%, 79%)"}, {"id": "Lilac", "label": "Lilac", "value": 0.9, "color": "hsl(278, 58%, 85%)"}, {"id": "Elm", "label": "Elm", "value": 2.0, "color": "hsl(204, 71%, 79%)"}, {"id": "Hawthorn", "label": "Hawthorn", "value": 2.5, "color": "hsl(0, 74%, 79%)"}, {"id": "Katsura Tree", "label": "Katsura Tree", "value": 1.5, "color": "hsl(273, 57%, 76%)"}, {"id": "Fir", "label": "Fir", "value": 0.1, "color": "hsl(124, 25%, 70%)"}, {"id": "Eucommia", "label": "Eucommia", "value": 0.0, "color": "hsl(34, 84%, 80%)"}, {"id": "Sweetgum", "label": "Sweetgum", "value": 1.1, "color": "hsl(72, 78%, 80%)"}, {"id": "Willow", "label": "Willow", "value": 0.1, "color": "hsl(144, 45%, 80%)"}, {"id": "Spruce", "label": "Spruce", "value": 0.4, "color": "hsl(185, 69%, 87%)"}, {"id": "Plane Tree", "label": "Plane Tree", "value": 1.2, "color": "hsl(18, 25%, 77%)"}, {"id": "Catalpa", "label": "Catalpa", "value": 0.4, "color": "hsl(60, 74%, 79%)"}, {"id": "Larch", "label": "Larch", "value": 0.0, "color": "hsl(147, 54%, 76%)"}, {"id": "Holly", "label": "Holly", "value": 0.1, "color": "hsl(169, 29%, 77%)"}, {"id": "Maackia", "label": "Maackia", "value": 0.0, "color": "hsl(30, 76%, 83%)"}, {"id": "Sourwood", "label": "Sourwood", "value": 0.0, "color": "hsl(203, 68%, 87%)"}, {"id": "Hornbeam", "label": "Hornbeam", "value": 4.1, "color": "hsl(194, 77%, 82%)"}, {"id": "Douglas Fir", "label": "Douglas Fir", "value": 0.5, "color": "hsl(139, 40%, 80%)"}, {"id": "Japanese Cedar", "label": "Japanese Cedar", "value": 0.0, "color": "hsl(267, 69%, 85%)"}, {"id": "Chestnut", "label": "Chestnut", "value": 0.0, "color": "hsl(37, 74%, 78%)"}, {"id": "Kentucky Coffee Tree", "label": "Kentucky Coffee Tree", "value": 0.1, "color": "hsl(82, 38%, 74%)"}, {"id": "Phellodendron", "label": "Phellodendron", "value": 0.0, "color": "hsl(18, 85%, 83%)"}, {"id": "Medlar", "label": "Medlar", "value": 0.0, "color": "hsl(47, 49%, 76%)"}, {"id": "Clerodendrum", "label": "Clerodendrum", "value": 0.0, "color": "hsl(316, 74%, 83%)"}, {"id": "Trachycarpus", "label": "Trachycarpus", "value": 0.0, "color": "hsl(44, 80%, 80%)"}, {"id": "Stump", "label": "Stump", "value": 0.0, "color": "hsl(11, 33%, 76%)"}, {"id": "Hickory", "label": "Hickory", "value": 0.0, "color": "hsl(45, 35%, 57%)"}, {"id": "Goldenrain Tree", "label": "Goldenrain Tree", "value": 0.1, "color": "hsl(56, 80%, 80%)"}, {"id": "Viburnum", "label": "Viburnum", "value": 0.0, "color": "hsl(47, 68%, 82%)"}, {"id": "Kalopanax", "label": "Kalopanax", "value": 0.0, "color": "hsl(94, 43%, 80%)"}, {"id": "Hazelnut", "label": "Hazelnut", "value": 0.1, "color": "hsl(0, 42%, 84%)"}, {"id": "Dawn Redwood", "label": "Dawn Redwood", "value": 0.3, "color": "hsl(100, 63%, 85%)"}, {"id": "Dove Tree", "label": "Dove Tree", "value": 0.1, "color": "hsl(20, 70%, 86%)"}, {"id": "Ironwood", "label": "Ironwood", "value": 0.1, "color": "hsl(94, 24%, 77%)"}, {"id": "Poplar", "label": "Poplar", "value": 0.1, "color": "hsl(207, 74%, 82%)"}, {"id": "Pterostyrax", "label": "Pterostyrax", "value": 0.0, "color": "hsl(27, 80%, 80%)"}, {"id": "Bald Cypress", "label": "Bald Cypress", "value": 0.0, "color": "hsl(82, 74%, 79%)"}, {"id": "Parrotia", "label": "Parrotia", "value": 1.8, "color": "hsl(0, 80%, 88%)"}, {"id": "Chitalpa", "label": "Chitalpa", "value": 0.0, "color": "hsl(287, 71%, 79%)"}, {"id": "Ash", "label": "Ash", "value": 5.0, "color": "hsl(36, 29%, 82%)"}, {"id": "Black Gum", "label": "Black Gum", "value": 0.9, "color": "hsl(120, 44%, 80%)"}, {"id": "Aralia", "label": "Aralia", "value": 0.0, "color": "hsl(43, 76%, 83%)"}, {"id": "Cherry", "label": "Cherry", "value": 19.1, "color": "hsl(347, 74%, 80%)"}, {"id": "Arborvitae", "label": "Arborvitae", "value": 0.8, "color": "hsl(189, 70%, 82%)"}, {"id": "Rowan", "label": "Rowan", "value": 1.1, "color": "hsl(342, 68%, 87%)"}, {"id": "Ptelea", "label": "Ptelea", "value": 0.0, "color": "hsl(72, 72%, 79%)"}, {"id": "Eucalyptus", "label": "Eucalyptus", "value": 0.0, "color": "hsl(160, 67%, 86%)"}, {"id": "Magnolia", "label": "Magnolia", "value": 2.7, "color": "hsl(89, 77%, 82%)"}, {"id": "Black Locust", "label": "Black Locust", "value": 0.4, "color": "hsl(99, 43%, 84%)"}, {"id": "Redbud", "label": "Redbud", "value": 0.4, "color": "hsl(327, 71%, 82%)"}, {"id": "Tulip Tree", "label": "Tulip Tree", "value": 0.6, "color": "hsl(34, 44%, 80%)"}, {"id": "Maple", "label": "Maple", "value": 24.9, "color": "hsl(97, 71%, 79%)"}, {"id": "Cunninghamia", "label": "Cunninghamia", "value": 0.0, "color": "hsl(196, 68%, 82%)"}, {"id": "Calocedrus", "label": "Calocedrus", "value": 0.0, "color": "hsl(91, 64%, 89%)"}, {"id": "Pear", "label": "Pear", "value": 1.3, "color": "hsl(37, 80%, 80%)"}, {"id": "Birch", "label": "Birch", "value": 1.0, "color": "hsl(51, 71%, 79%)"}, {"id": "Crape Myrtle", "label": "Crape Myrtle", "value": 0.0, "color": "hsl(322, 55%, 89%)"}, {"id": "Zelkova", "label": "Zelkova", "value": 0.4, "color": "hsl(94, 40%, 79%)"}, {"id": "Honey Locust", "label": "Honey Locust", "value": 1.2, "color": "hsl(51, 75%, 79%)"}, {"id": "Hemlock", "label": "Hemlock", "value": 0.1, "color": "hsl(200, 43%, 79%)"}, {"id": "Yew", "label": "Yew", "value": 0.0, "color": "hsl(140, 32%, 72%)"}, {"id": "False Cypress", "label": "False Cypress", "value": 0.4, "color": "hsl(135, 52%, 80%)"}, {"id": "Sea Buckthorn", "label": "Sea Buckthorn", "value": 0.0, "color": "hsl(26, 47%, 79%)"}, {"id": "Ginkgo", "label": "Ginkgo", "value": 0.3, "color": "hsl(77, 52%, 76%)"}, {"id": "Sophora", "label": "Sophora", "value": 0.0, "color": "hsl(22, 64%, 85%)"}, {"id": "Sequoia", "label": "Sequoia", "value": 0.0, "color": "hsl(163, 26%, 86%)"}, {"id": "Bay Laurel", "label": "Bay Laurel", "value": 0.0, "color": "hsl(144, 30%, 76%)"}, {"id": "Apple", "label": "Apple", "value": 2.6, "color": "hsl(0, 69%, 82%)"}, {"id": "Buckthorn", "label": "Buckthorn", "value": 0.0, "color": "hsl(265, 50%, 80%)"}, {"id": "Cypress", "label": "Cypress", "value": 0.0, "color": "hsl(146, 76%, 83%)"}, {"id": "Southern Beech", "label": "Southern Beech", "value": 0.0, "color": "hsl(43, 67%, 85%)"}, {"id": "Burning Bush", "label": "Burning Bush", "value": 0.0, "color": "hsl(92, 48%, 88%)"}, {"id": "Strawberry Tree", "label": "Strawberry Tree", "value": 0.0, "color": "hsl(19, 71%, 82%)"}, {"id": "Alder", "label": "Alder", "value": 0.0, "color": "hsl(80, 42%, 78%)"}, {"id": "Cypress", "label": "Cypress", "value": 0.1, "color": "hsl(212, 69%, 83%)"}, {"id": "Linden", "label": "Linden", "value": 4.3, "color": "hsl(87, 71%, 82%)"}, {"id": "Stewartia", "label": "Stewartia", "value": 0.2, "color": "hsl(284, 63%, 86%)"}, {"id": "Pine", "label": "Pine", "value": 0.5, "color": "hsl(93, 76%, 80%)"}, {"id": "Seven Sons Flower", "label": "Seven Sons Flower", "value": 0.0, "color": "hsl(325, 51%, 89%)"}, {"id": "Hibiscus", "label": "Hibiscus", "value": 0.1, "color": "hsl(330, 68%, 82%)"}, {"id": "Cedar", "label": "Cedar", "value": 0.2, "color": "hsl(167, 61%, 84%)"}, {"id": "Mulberry", "label": "Mulberry", "value": 0.0, "color": "hsl(46, 70%, 82%)"}, {"id": "Empress Tree", "label": "Empress Tree", "value": 0.0, "color": "hsl(279, 56%, 86%)"}, {"id": "Serviceberry", "label": "Serviceberry", "value": 0.2, "color": "hsl(129, 55%, 88%)"}, {"id": "Dogwood", "label": "Dogwood", "value": 1.5, "color": "hsl(24, 42%, 78%)"}, {"id": "Yellowwood", "label": "Yellowwood", "value": 0.0, "color": "hsl(60, 56%, 76%)"}, {"id": "Juniper", "label": "Juniper", "value": 0.0, "color": "hsl(194, 43%, 79%)"}, {"id": "Beech", "label": "Beech", "value": 3.7, "color": "hsl(95, 48%, 79%)"}, {"id": "Walnut", "label": "Walnut", "value": 0.1, "color": "hsl(75, 34%, 81%)"}, {"id": "Silk Tree", "label": "Silk Tree", "value": 0.0, "color": "hsl(15, 75%, 82%)"}, {"id": "Michelia", "label": "Michelia", "value": 0.0, "color": "hsl(37, 57%, 86%)"}, {"id": "Fig", "label": "Fig", "value": 0.0, "color": "hsl(153, 70%, 82%)"}, {"id": "Buckeye", "label": "Buckeye", "value": 1.7, "color": "hsl(92, 67%, 82%)"}, {"id": "Monkey Puzzle Tree", "label": "Monkey Puzzle Tree", "value": 0.0, "color": "hsl(163, 69%, 82%)"}, {"id": "Oak", "label": "Oak", "value": 4.6, "color": "hsl(103, 53%, 80%)"}, {"id": "Hackberry", "label": "Hackberry", "value": 0.2, "color": "hsl(96, 35%, 83%)"}, {"id": "Japanese Umbrella Pine", "label": "Japanese Umbrella Pine", "value": 0.0, "color": "hsl(198, 19%, 86%)"}
        ],
    "Arbutus Ridge": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 1,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 208,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 27,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 376,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 130,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 73,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 119,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 9,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 131,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 2,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 4,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 9,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1400,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 2,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 73,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 59,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 22,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 1,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 159,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 19,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 1,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 5,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 13,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 7,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 2,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 5,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 4,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 134,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 3,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 5,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 6,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 92,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 184,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 1,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 3,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 115,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 20,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 37,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 115,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Maackia",
            "label": "Maackia",
            "value": 3,
            "color": "hsl(30, 76%, 83%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 188,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 878,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Medlar",
            "label": "Medlar",
            "value": 6,
            "color": "hsl(47, 49%, 76%)"
        },
        {
            "id": "Monkey Puzzle Tree",
            "label": "Monkey Puzzle Tree",
            "value": 1,
            "color": "hsl(163, 69%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 73,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 42,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 92,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 39,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 101,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 2,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 11,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 58,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Sequoia",
            "label": "Sequoia",
            "value": 1,
            "color": "hsl(163, 26%, 86%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 35,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 6,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 2,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 21,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 47,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 44,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 12,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 10,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 1,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 46,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Downtown": [
        {
            "id": "Apple",
            "label": "Apple",
            "value": 4,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 3,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 70,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 396,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 36,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 51,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 5,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 16,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 1,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 1,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 114,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 1,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 13,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 1,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 62,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 1,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 3,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 69,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 1,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 19,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 126,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 326,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 1,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 48,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 3,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 188,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 47,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1906,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 444,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 141,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 80,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 3,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 97,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 1,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 7,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 4,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 10,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 157,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Trachycarpus",
            "label": "Trachycarpus",
            "value": 7,
            "color": "hsl(44, 80%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 160,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 1,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 2,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Dunbar-Southlands": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 13,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 303,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 99,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 220,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 1,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 174,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 163,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 26,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 46,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 284,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Burning Bush",
            "label": "Burning Bush",
            "value": 1,
            "color": "hsl(92, 48%, 88%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 30,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 30,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 2425,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 10,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 5,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 8,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 121,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 57,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 14,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 467,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Empress Tree",
            "label": "Empress Tree",
            "value": 4,
            "color": "hsl(279, 56%, 86%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 59,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 1,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 11,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 25,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 12,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 12,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 6,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 21,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 188,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 4,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 14,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 2,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 16,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 65,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 75,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Japanese Cedar",
            "label": "Japanese Cedar",
            "value": 1,
            "color": "hsl(267, 69%, 85%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 1,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 168,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 12,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Larch",
            "label": "Larch",
            "value": 1,
            "color": "hsl(147, 54%, 76%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 35,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 103,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 109,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 2393,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Monkey Puzzle Tree",
            "label": "Monkey Puzzle Tree",
            "value": 2,
            "color": "hsl(163, 69%, 82%)"
        },
        {
            "id": "Mulberry",
            "label": "Mulberry",
            "value": 1,
            "color": "hsl(46, 70%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 708,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 112,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 32,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 50,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 166,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 15,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 11,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 78,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 12,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 95,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 19,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Strawberry Tree",
            "label": "Strawberry Tree",
            "value": 1,
            "color": "hsl(19, 71%, 82%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 107,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 6,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 30,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tree of Heaven",
            "label": "Tree of Heaven",
            "value": 1,
            "color": "hsl(41, 85%, 83%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 26,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 12,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 5,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 1,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 1,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 24,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Fairview": [
        {
            "id": "Apple",
            "label": "Apple",
            "value": 70,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 18,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 149,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 164,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 35,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 53,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 9,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 48,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Burning Bush",
            "label": "Burning Bush",
            "value": 2,
            "color": "hsl(92, 48%, 88%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 19,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 10,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 612,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 1,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 6,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 34,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 7,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 3,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 120,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Empress Tree",
            "label": "Empress Tree",
            "value": 2,
            "color": "hsl(279, 56%, 86%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 15,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 1,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 7,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 5,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 13,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 54,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 6,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 11,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 2,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 112,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 154,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 39,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 6,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 68,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 193,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 47,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1372,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Monkey Puzzle Tree",
            "label": "Monkey Puzzle Tree",
            "value": 1,
            "color": "hsl(163, 69%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 212,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 57,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 57,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 69,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 18,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 1,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 1,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 9,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 8,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Silk Tree",
            "label": "Silk Tree",
            "value": 1,
            "color": "hsl(15, 75%, 82%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 15,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Strawberry Tree",
            "label": "Strawberry Tree",
            "value": 1,
            "color": "hsl(19, 71%, 82%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 40,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 1,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 34,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 54,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 1,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 3,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 5,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 8,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Grandview-Woodland": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 2,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 200,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Aralia",
            "label": "Aralia",
            "value": 1,
            "color": "hsl(43, 76%, 83%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 61,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 281,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 280,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 36,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 74,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 21,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 89,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Burning Bush",
            "label": "Burning Bush",
            "value": 1,
            "color": "hsl(92, 48%, 88%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 19,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 13,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1058,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 2,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 6,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 8,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 80,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 13,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 6,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 312,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 24,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 1,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 5,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 2,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 21,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 7,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 5,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 125,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 3,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 4,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 7,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 14,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 22,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 420,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 2,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 71,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 3,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Larch",
            "label": "Larch",
            "value": 1,
            "color": "hsl(147, 54%, 76%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 40,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 331,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 208,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1756,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Mulberry",
            "label": "Mulberry",
            "value": 2,
            "color": "hsl(46, 70%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 345,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 154,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 72,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 22,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 85,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 4,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 17,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 66,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Sea Buckthorn",
            "label": "Sea Buckthorn",
            "value": 3,
            "color": "hsl(26, 47%, 79%)"
        },
        {
            "id": "Sequoia",
            "label": "Sequoia",
            "value": 1,
            "color": "hsl(163, 26%, 86%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 21,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Seven Sons Flower",
            "label": "Seven Sons Flower",
            "value": 1,
            "color": "hsl(325, 51%, 89%)"
        },
        {
            "id": "Silk Tree",
            "label": "Silk Tree",
            "value": 3,
            "color": "hsl(15, 75%, 82%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 19,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 10,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 135,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 3,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 39,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 32,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 8,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 1,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 22,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Hastings-Sunrise": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 1,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 364,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Aralia",
            "label": "Aralia",
            "value": 2,
            "color": "hsl(43, 76%, 83%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 30,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 552,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 2,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 337,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 11,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 119,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 55,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 89,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Buckthorn",
            "label": "Buckthorn",
            "value": 1,
            "color": "hsl(265, 50%, 80%)"
        },
        {
            "id": "Burning Bush",
            "label": "Burning Bush",
            "value": 8,
            "color": "hsl(92, 48%, 88%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 2,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 18,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 20,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1567,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 11,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 2,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 55,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 196,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 32,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 2,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 4,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 25,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 2,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 9,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 1,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 24,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 11,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 27,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 14,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 565,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 8,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 9,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 36,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 4,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 123,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 618,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 14,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 3,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 215,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 15,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Larch",
            "label": "Larch",
            "value": 1,
            "color": "hsl(147, 54%, 76%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 138,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 329,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 348,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 2497,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Mulberry",
            "label": "Mulberry",
            "value": 2,
            "color": "hsl(46, 70%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 426,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 199,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 121,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 94,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 78,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 2,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 47,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 259,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Sequoia",
            "label": "Sequoia",
            "value": 2,
            "color": "hsl(163, 26%, 86%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 61,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 23,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 11,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 137,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 1,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 147,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Trachycarpus",
            "label": "Trachycarpus",
            "value": 2,
            "color": "hsl(44, 80%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 42,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 3,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 3,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 1,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 3,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 34,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Kensington-Cedar Cottage": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 1,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 309,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 99,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 1230,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 570,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 53,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 151,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 49,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 216,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Buckthorn",
            "label": "Buckthorn",
            "value": 3,
            "color": "hsl(265, 50%, 80%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 3,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 8,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 11,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1747,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 13,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 5,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 17,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 135,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 63,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 19,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 43,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 44,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 1,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 11,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 2,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 21,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 14,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 11,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 36,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 378,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 9,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 16,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 12,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 20,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 71,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 656,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Japanese Cedar",
            "label": "Japanese Cedar",
            "value": 1,
            "color": "hsl(267, 69%, 85%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 7,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 129,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 12,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 94,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 700,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Maackia",
            "label": "Maackia",
            "value": 3,
            "color": "hsl(30, 76%, 83%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 362,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 2518,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Medlar",
            "label": "Medlar",
            "value": 1,
            "color": "hsl(47, 49%, 76%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 468,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 182,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 110,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 33,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 115,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 23,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 36,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 124,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 23,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Seven Sons Flower",
            "label": "Seven Sons Flower",
            "value": 2,
            "color": "hsl(325, 51%, 89%)"
        },
        {
            "id": "Sourwood",
            "label": "Sourwood",
            "value": 1,
            "color": "hsl(203, 68%, 87%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 47,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 10,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 150,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 3,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 58,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Trachycarpus",
            "label": "Trachycarpus",
            "value": 1,
            "color": "hsl(44, 80%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 81,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 18,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 13,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 1,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 8,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Kerrisdale": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 6,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 225,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 64,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 262,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 5,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 103,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 200,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 10,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 43,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 129,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 28,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 9,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1479,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 1,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 1,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 11,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 190,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 29,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 11,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 270,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 21,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 7,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 11,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 2,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 8,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 3,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 76,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 10,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 2,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 13,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 12,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 76,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 92,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Japanese Umbrella Pine",
            "label": "Japanese Umbrella Pine",
            "value": 1,
            "color": "hsl(198, 19%, 86%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 1,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 173,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 17,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 157,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 346,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1879,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 301,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 85,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 15,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 19,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 58,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 20,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 8,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 55,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 7,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Sourwood",
            "label": "Sourwood",
            "value": 1,
            "color": "hsl(203, 68%, 87%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 16,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 4,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Strawberry Tree",
            "label": "Strawberry Tree",
            "value": 1,
            "color": "hsl(19, 71%, 82%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 84,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 34,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 4,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 7,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 10,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 3,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 44,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Killarney": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 3,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 94,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 21,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 383,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 4,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 211,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 36,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 48,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 5,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 7,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 8,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 3,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1136,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Crape Myrtle",
            "label": "Crape Myrtle",
            "value": 1,
            "color": "hsl(322, 55%, 89%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 62,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 196,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 37,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 10,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 44,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 15,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 1,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 23,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 1,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 1,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 16,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 169,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 6,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 2,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 1,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 1,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 63,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 389,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 16,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 109,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 10,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 89,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 681,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Maackia",
            "label": "Maackia",
            "value": 6,
            "color": "hsl(30, 76%, 83%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 181,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1410,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Monkey Puzzle Tree",
            "label": "Monkey Puzzle Tree",
            "value": 2,
            "color": "hsl(163, 69%, 82%)"
        },
        {
            "id": "Mulberry",
            "label": "Mulberry",
            "value": 1,
            "color": "hsl(46, 70%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 487,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 87,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 48,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 21,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 83,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 2,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 40,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 41,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 9,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Seven Sons Flower",
            "label": "Seven Sons Flower",
            "value": 1,
            "color": "hsl(325, 51%, 89%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 13,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 8,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 44,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 68,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 11,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 10,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 2,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 13,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Kitsilano": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 6,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 125,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 145,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 209,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bay Laurel",
            "label": "Bay Laurel",
            "value": 1,
            "color": "hsl(144, 30%, 76%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 236,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 73,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 13,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 40,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 292,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Buckthorn",
            "label": "Buckthorn",
            "value": 1,
            "color": "hsl(265, 50%, 80%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 3,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 187,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 43,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1166,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 1,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 16,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 14,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 90,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 48,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 1,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 152,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Empress Tree",
            "label": "Empress Tree",
            "value": 1,
            "color": "hsl(279, 56%, 86%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 93,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 1,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 9,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 12,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 3,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 6,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 1,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 180,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 3,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 16,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 6,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 26,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 71,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 186,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 2,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Japanese Cedar",
            "label": "Japanese Cedar",
            "value": 1,
            "color": "hsl(267, 69%, 85%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 3,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 81,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 80,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 510,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 361,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 2238,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Medlar",
            "label": "Medlar",
            "value": 8,
            "color": "hsl(47, 49%, 76%)"
        },
        {
            "id": "Monkey Puzzle Tree",
            "label": "Monkey Puzzle Tree",
            "value": 4,
            "color": "hsl(163, 69%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 433,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 122,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 91,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 56,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 134,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 9,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 11,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 71,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 2,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Sophora",
            "label": "Sophora",
            "value": 8,
            "color": "hsl(22, 64%, 85%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 44,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 4,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Strawberry Tree",
            "label": "Strawberry Tree",
            "value": 1,
            "color": "hsl(19, 71%, 82%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 166,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 1,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 50,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Trachycarpus",
            "label": "Trachycarpus",
            "value": 1,
            "color": "hsl(44, 80%, 80%)"
        },
        {
            "id": "Tree of Heaven",
            "label": "Tree of Heaven",
            "value": 1,
            "color": "hsl(41, 85%, 83%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 96,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 8,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 9,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 2,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 1,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 2,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 5,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Marpole": [
        {
            "id": "Apple",
            "label": "Apple",
            "value": 197,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 78,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 392,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 3,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 166,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 28,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 76,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 21,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 79,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 5,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 15,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1639,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chitalpa",
            "label": "Chitalpa",
            "value": 1,
            "color": "hsl(287, 71%, 79%)"
        },
        {
            "id": "Clerodendrum",
            "label": "Clerodendrum",
            "value": 2,
            "color": "hsl(316, 74%, 83%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 24,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 19,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 180,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 38,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 1,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 73,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 31,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 1,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 2,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 3,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 8,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 3,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 1,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 7,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 129,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 2,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 6,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 4,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 8,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 35,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 358,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 1,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 1,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 73,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 2,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 63,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 84,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Maackia",
            "label": "Maackia",
            "value": 2,
            "color": "hsl(30, 76%, 83%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 159,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1448,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 365,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 155,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 83,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 33,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 57,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 20,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 27,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 48,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 24,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Southern Beech",
            "label": "Southern Beech",
            "value": 6,
            "color": "hsl(43, 67%, 85%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 19,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 9,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 55,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 1,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 87,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 36,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 2,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 2,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 2,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 34,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Mount Pleasant": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 4,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 78,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 49,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 241,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 264,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 42,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 105,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 45,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 243,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Buckthorn",
            "label": "Buckthorn",
            "value": 1,
            "color": "hsl(265, 50%, 80%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 1,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 6,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1151,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 2,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 7,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 14,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 75,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 13,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 22,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 79,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Eucommia",
            "label": "Eucommia",
            "value": 1,
            "color": "hsl(34, 84%, 80%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 27,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 2,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 4,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 10,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 24,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 3,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 1,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 9,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 91,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 2,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 3,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 5,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 7,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 34,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 281,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 5,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Japanese Cedar",
            "label": "Japanese Cedar",
            "value": 2,
            "color": "hsl(267, 69%, 85%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 138,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 3,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 59,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 310,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Maackia",
            "label": "Maackia",
            "value": 1,
            "color": "hsl(30, 76%, 83%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 90,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1845,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Monkey Puzzle Tree",
            "label": "Monkey Puzzle Tree",
            "value": 1,
            "color": "hsl(163, 69%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 322,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 133,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 300,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 58,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 45,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 11,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 22,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 54,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 4,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Sophora",
            "label": "Sophora",
            "value": 1,
            "color": "hsl(22, 64%, 85%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 22,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 39,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 62,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 1,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 157,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Trachycarpus",
            "label": "Trachycarpus",
            "value": 1,
            "color": "hsl(44, 80%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 31,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 7,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 8,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 9,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 10,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Oakridge": [
        {
            "id": "Apple",
            "label": "Apple",
            "value": 71,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 73,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 280,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 118,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 37,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 45,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 24,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 6,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 2,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 1,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 14,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1337,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 30,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 3,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 85,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 36,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 6,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 72,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 29,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 5,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 8,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 43,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 1,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 17,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 70,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 1,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 2,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hickory",
            "label": "Hickory",
            "value": 1,
            "color": "hsl(45, 35%, 57%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 1,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 121,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 96,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 5,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 2,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 218,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 11,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 20,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 46,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 201,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 933,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Monkey Puzzle Tree",
            "label": "Monkey Puzzle Tree",
            "value": 1,
            "color": "hsl(163, 69%, 82%)"
        },
        {
            "id": "Mulberry",
            "label": "Mulberry",
            "value": 1,
            "color": "hsl(46, 70%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 292,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 69,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 25,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Phellodendron",
            "label": "Phellodendron",
            "value": 2,
            "color": "hsl(18, 85%, 83%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 30,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 30,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 3,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 102,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 17,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 51,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 23,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 53,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 8,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 1,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 1,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 1,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 26,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Renfrew-Collingwood": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 3,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 469,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 143,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 605,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 3,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 596,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 31,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 127,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 25,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 42,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 5,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 6,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 15,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 2262,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 4,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 3,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 7,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 130,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 88,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 16,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 12,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 26,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 1,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 10,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 3,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 35,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 3,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 20,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 93,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 380,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 20,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 14,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 17,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 14,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 132,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 542,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 4,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 44,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Kalopanax",
            "label": "Kalopanax",
            "value": 1,
            "color": "hsl(94, 43%, 80%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 184,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 12,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 295,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 537,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 351,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 2612,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Medlar",
            "label": "Medlar",
            "value": 5,
            "color": "hsl(47, 49%, 76%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 385,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 333,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 213,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 42,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 79,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 16,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 100,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 175,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Sequoia",
            "label": "Sequoia",
            "value": 1,
            "color": "hsl(163, 26%, 86%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 23,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Sophora",
            "label": "Sophora",
            "value": 5,
            "color": "hsl(22, 64%, 85%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 49,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 33,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Strawberry Tree",
            "label": "Strawberry Tree",
            "value": 1,
            "color": "hsl(19, 71%, 82%)"
        },
        {
            "id": "Stump",
            "label": "Stump",
            "value": 1,
            "color": "hsl(11, 33%, 76%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 129,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 55,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tree of Heaven",
            "label": "Tree of Heaven",
            "value": 1,
            "color": "hsl(41, 85%, 83%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 61,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 9,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 2,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 1,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 2,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 66,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Riley Park": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 3,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 188,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Aralia",
            "label": "Aralia",
            "value": 1,
            "color": "hsl(43, 76%, 83%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 93,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 389,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 2,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 285,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 33,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 40,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 17,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 62,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Buckthorn",
            "label": "Buckthorn",
            "value": 4,
            "color": "hsl(265, 50%, 80%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 5,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 15,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 16,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1449,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 3,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 3,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 5,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 72,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 33,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 14,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 32,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Empress Tree",
            "label": "Empress Tree",
            "value": 1,
            "color": "hsl(279, 56%, 86%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 33,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 5,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 8,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 16,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 2,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 3,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 14,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 130,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 2,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 8,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 2,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 10,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 108,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 303,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 3,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 45,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 4,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 16,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 396,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Maackia",
            "label": "Maackia",
            "value": 4,
            "color": "hsl(30, 76%, 83%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 217,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1832,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Michelia",
            "label": "Michelia",
            "value": 1,
            "color": "hsl(37, 57%, 86%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 238,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 229,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 74,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 35,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 53,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 27,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 45,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 54,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 23,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Seven Sons Flower",
            "label": "Seven Sons Flower",
            "value": 3,
            "color": "hsl(325, 51%, 89%)"
        },
        {
            "id": "Southern Beech",
            "label": "Southern Beech",
            "value": 1,
            "color": "hsl(43, 67%, 85%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 60,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 5,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Stump",
            "label": "Stump",
            "value": 2,
            "color": "hsl(11, 33%, 76%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 99,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 1,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 120,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 28,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 4,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 15,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 18,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 1,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 12,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Shaughnessy": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 2,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 159,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 79,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 153,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 2,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Bay Laurel",
            "label": "Bay Laurel",
            "value": 3,
            "color": "hsl(144, 30%, 76%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 66,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 96,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 17,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 33,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 378,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 6,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 28,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 33,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 1181,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 14,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cunninghamia",
            "label": "Cunninghamia",
            "value": 1,
            "color": "hsl(196, 68%, 82%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 2,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 24,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 75,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 21,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 16,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 641,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 56,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 6,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 16,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 9,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 17,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 149,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 5,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 8,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 6,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 22,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 98,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 74,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 1,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Japanese Umbrella Pine",
            "label": "Japanese Umbrella Pine",
            "value": 2,
            "color": "hsl(198, 19%, 86%)"
        },
        {
            "id": "Juniper",
            "label": "Juniper",
            "value": 3,
            "color": "hsl(194, 43%, 79%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 95,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 3,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 14,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 230,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 140,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1969,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Monkey Puzzle Tree",
            "label": "Monkey Puzzle Tree",
            "value": 1,
            "color": "hsl(163, 69%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 70,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 74,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 20,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 17,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 232,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 13,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 48,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Sequoia",
            "label": "Sequoia",
            "value": 1,
            "color": "hsl(163, 26%, 86%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 7,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Sophora",
            "label": "Sophora",
            "value": 1,
            "color": "hsl(22, 64%, 85%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 23,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 28,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 146,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 102,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 15,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 7,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 1,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 3,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 12,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 20,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "South Cambie": [
        {
            "id": "Apple",
            "label": "Apple",
            "value": 143,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 40,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 165,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 2,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 107,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 12,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 27,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 5,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 20,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 1,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 1,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 21,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 593,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 2,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 28,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 111,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 17,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 7,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 139,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Empress Tree",
            "label": "Empress Tree",
            "value": 2,
            "color": "hsl(279, 56%, 86%)"
        },
        {
            "id": "Eucommia",
            "label": "Eucommia",
            "value": 6,
            "color": "hsl(34, 84%, 80%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 39,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 3,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 21,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 10,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 3,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 84,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 2,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 2,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 9,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 80,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 66,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Japanese Cedar",
            "label": "Japanese Cedar",
            "value": 4,
            "color": "hsl(267, 69%, 85%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 33,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 1,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Larch",
            "label": "Larch",
            "value": 2,
            "color": "hsl(147, 54%, 76%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 5,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 85,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 75,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 922,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Mulberry",
            "label": "Mulberry",
            "value": 1,
            "color": "hsl(46, 70%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 113,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 24,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 9,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Phellodendron",
            "label": "Phellodendron",
            "value": 3,
            "color": "hsl(18, 85%, 83%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 15,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 46,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 1,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 3,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 34,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Sequoia",
            "label": "Sequoia",
            "value": 1,
            "color": "hsl(163, 26%, 86%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 7,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 25,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 12,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 36,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 54,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 2,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 6,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 6,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 1,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 3,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Strathcona": [
        {
            "id": "Apple",
            "label": "Apple",
            "value": 20,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 15,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 76,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 213,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 20,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 45,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 3,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 19,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Buckthorn",
            "label": "Buckthorn",
            "value": 1,
            "color": "hsl(265, 50%, 80%)"
        },
        {
            "id": "Calocedrus",
            "label": "Calocedrus",
            "value": 2,
            "color": "hsl(91, 64%, 89%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 3,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 272,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 55,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 6,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 69,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Eucalyptus",
            "label": "Eucalyptus",
            "value": 1,
            "color": "hsl(160, 67%, 86%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 5,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 1,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 4,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 2,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 14,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 8,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 34,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 3,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 66,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 211,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 8,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 8,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 22,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 134,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Maackia",
            "label": "Maackia",
            "value": 8,
            "color": "hsl(30, 76%, 83%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 30,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 533,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Mulberry",
            "label": "Mulberry",
            "value": 1,
            "color": "hsl(46, 70%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 181,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 139,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 151,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 88,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 37,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 3,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 50,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 26,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 19,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Seven Sons Flower",
            "label": "Seven Sons Flower",
            "value": 8,
            "color": "hsl(325, 51%, 89%)"
        },
        {
            "id": "Silk Tree",
            "label": "Silk Tree",
            "value": 1,
            "color": "hsl(15, 75%, 82%)"
        },
        {
            "id": "Southern Beech",
            "label": "Southern Beech",
            "value": 2,
            "color": "hsl(43, 67%, 85%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 11,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 8,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 9,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 1,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 1,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 3,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 9,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 3,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 1,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Sunset": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 2,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 186,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 22,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 529,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 343,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 59,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 78,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 14,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 53,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 8,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 21,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 2045,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 2,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Crape Myrtle",
            "label": "Crape Myrtle",
            "value": 1,
            "color": "hsl(322, 55%, 89%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 5,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 25,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 65,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 43,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 10,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 30,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Empress Tree",
            "label": "Empress Tree",
            "value": 2,
            "color": "hsl(279, 56%, 86%)"
        },
        {
            "id": "Eucommia",
            "label": "Eucommia",
            "value": 10,
            "color": "hsl(34, 84%, 80%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 20,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fig",
            "label": "Fig",
            "value": 3,
            "color": "hsl(153, 70%, 82%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 3,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 17,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 7,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 10,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 20,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 267,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 20,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 2,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 32,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 16,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 123,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 532,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 24,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 98,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 8,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 39,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 458,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Maackia",
            "label": "Maackia",
            "value": 5,
            "color": "hsl(30, 76%, 83%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 83,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 2029,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Monkey Puzzle Tree",
            "label": "Monkey Puzzle Tree",
            "value": 1,
            "color": "hsl(163, 69%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 372,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 120,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 194,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 29,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 75,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 6,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Pterostyrax",
            "label": "Pterostyrax",
            "value": 1,
            "color": "hsl(27, 80%, 80%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 12,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 101,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 29,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Seven Sons Flower",
            "label": "Seven Sons Flower",
            "value": 4,
            "color": "hsl(325, 51%, 89%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 21,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 2,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Strawberry Tree",
            "label": "Strawberry Tree",
            "value": 1,
            "color": "hsl(19, 71%, 82%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 71,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 1,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 100,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tree of Heaven",
            "label": "Tree of Heaven",
            "value": 1,
            "color": "hsl(41, 85%, 83%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 84,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Viburnum",
            "label": "Viburnum",
            "value": 5,
            "color": "hsl(47, 68%, 82%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 6,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 4,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 1,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 19,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Yew",
            "label": "Yew",
            "value": 1,
            "color": "hsl(140, 32%, 72%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 76,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "Victoria-Fraserview": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 1,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 176,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 31,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 605,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 554,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 37,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 116,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 29,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 66,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 1,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 28,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 2011,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 6,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 3,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dawn Redwood",
            "label": "Dawn Redwood",
            "value": 20,
            "color": "hsl(100, 63%, 85%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 100,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 54,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 1,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 54,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 13,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 22,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 8,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 21,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 6,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Goldenrain Tree",
            "label": "Goldenrain Tree",
            "value": 26,
            "color": "hsl(56, 80%, 80%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 18,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 265,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 2,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 11,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 2,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 4,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 123,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 283,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Ironwood",
            "label": "Ironwood",
            "value": 8,
            "color": "hsl(94, 24%, 77%)"
        },
        {
            "id": "Japanese Cedar",
            "label": "Japanese Cedar",
            "value": 1,
            "color": "hsl(267, 69%, 85%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 75,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 30,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Larch",
            "label": "Larch",
            "value": 6,
            "color": "hsl(147, 54%, 76%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 90,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 443,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Maackia",
            "label": "Maackia",
            "value": 20,
            "color": "hsl(30, 76%, 83%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 297,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1405,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Mulberry",
            "label": "Mulberry",
            "value": 1,
            "color": "hsl(46, 70%, 82%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 369,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 166,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 62,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 5,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 81,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 7,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 18,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 143,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 10,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Seven Sons Flower",
            "label": "Seven Sons Flower",
            "value": 1,
            "color": "hsl(325, 51%, 89%)"
        },
        {
            "id": "Southern Beech",
            "label": "Southern Beech",
            "value": 1,
            "color": "hsl(43, 67%, 85%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 13,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 2,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 40,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 52,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 22,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 14,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 2,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 16,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 86,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "West End": [
        {
            "id": "Apple",
            "label": "Apple",
            "value": 76,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 15,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 59,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bay Laurel",
            "label": "Bay Laurel",
            "value": 1,
            "color": "hsl(144, 30%, 76%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 133,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 150,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 12,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 16,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 86,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 48,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 7,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 704,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Chestnut",
            "label": "Chestnut",
            "value": 1,
            "color": "hsl(37, 74%, 78%)"
        },
        {
            "id": "Chitalpa",
            "label": "Chitalpa",
            "value": 1,
            "color": "hsl(287, 71%, 79%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 14,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 27,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 3,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 19,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 19,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "Eucalyptus",
            "label": "Eucalyptus",
            "value": 1,
            "color": "hsl(160, 67%, 86%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 18,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 8,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 148,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 10,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 1,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 9,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 1,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 21,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 119,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 33,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 2,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 13,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 133,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 37,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1168,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 98,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 44,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 13,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 12,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 19,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Poplar",
            "label": "Poplar",
            "value": 2,
            "color": "hsl(207, 74%, 82%)"
        },
        {
            "id": "Ptelea",
            "label": "Ptelea",
            "value": 2,
            "color": "hsl(72, 72%, 79%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 16,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 12,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 1,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 1,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 2,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 65,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Trachycarpus",
            "label": "Trachycarpus",
            "value": 1,
            "color": "hsl(44, 80%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 39,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 13,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Willow",
            "label": "Willow",
            "value": 2,
            "color": "hsl(144, 45%, 80%)"
        },
        {
            "id": "Wingnut",
            "label": "Wingnut",
            "value": 1,
            "color": "hsl(142, 42%, 79%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 4,
            "color": "hsl(94, 40%, 79%)"
        }
    ],
    "West Point Grey": [
        {
            "id": "Alder",
            "label": "Alder",
            "value": 5,
            "color": "hsl(80, 42%, 78%)"
        },
        {
            "id": "Apple",
            "label": "Apple",
            "value": 226,
            "color": "hsl(0, 69%, 82%)"
        },
        {
            "id": "Arborvitae",
            "label": "Arborvitae",
            "value": 34,
            "color": "hsl(189, 70%, 82%)"
        },
        {
            "id": "Ash",
            "label": "Ash",
            "value": 158,
            "color": "hsl(36, 29%, 82%)"
        },
        {
            "id": "Bald Cypress",
            "label": "Bald Cypress",
            "value": 1,
            "color": "hsl(82, 74%, 79%)"
        },
        {
            "id": "Beech",
            "label": "Beech",
            "value": 41,
            "color": "hsl(95, 48%, 79%)"
        },
        {
            "id": "Birch",
            "label": "Birch",
            "value": 162,
            "color": "hsl(51, 71%, 79%)"
        },
        {
            "id": "Black Gum",
            "label": "Black Gum",
            "value": 42,
            "color": "hsl(120, 44%, 80%)"
        },
        {
            "id": "Black Locust",
            "label": "Black Locust",
            "value": 13,
            "color": "hsl(99, 43%, 84%)"
        },
        {
            "id": "Buckeye",
            "label": "Buckeye",
            "value": 162,
            "color": "hsl(92, 67%, 82%)"
        },
        {
            "id": "Catalpa",
            "label": "Catalpa",
            "value": 85,
            "color": "hsl(60, 74%, 79%)"
        },
        {
            "id": "Cedar",
            "label": "Cedar",
            "value": 10,
            "color": "hsl(167, 61%, 84%)"
        },
        {
            "id": "Cherry",
            "label": "Cherry",
            "value": 923,
            "color": "hsl(347, 74%, 80%)"
        },
        {
            "id": "Cypress",
            "label": "Cypress",
            "value": 12,
            "color": "hsl(212, 69%, 83%)"
        },
        {
            "id": "Dogwood",
            "label": "Dogwood",
            "value": 154,
            "color": "hsl(24, 42%, 78%)"
        },
        {
            "id": "Douglas Fir",
            "label": "Douglas Fir",
            "value": 49,
            "color": "hsl(139, 40%, 80%)"
        },
        {
            "id": "Dove Tree",
            "label": "Dove Tree",
            "value": 3,
            "color": "hsl(20, 70%, 86%)"
        },
        {
            "id": "Elm",
            "label": "Elm",
            "value": 163,
            "color": "hsl(204, 71%, 79%)"
        },
        {
            "id": "False Cypress",
            "label": "False Cypress",
            "value": 13,
            "color": "hsl(135, 52%, 80%)"
        },
        {
            "id": "Fir",
            "label": "Fir",
            "value": 18,
            "color": "hsl(124, 25%, 70%)"
        },
        {
            "id": "Giant Sequoia",
            "label": "Giant Sequoia",
            "value": 14,
            "color": "hsl(158, 76%, 86%)"
        },
        {
            "id": "Ginkgo",
            "label": "Ginkgo",
            "value": 4,
            "color": "hsl(77, 52%, 76%)"
        },
        {
            "id": "Golden Chain",
            "label": "Golden Chain",
            "value": 7,
            "color": "hsl(42, 100%, 85%)"
        },
        {
            "id": "Hackberry",
            "label": "Hackberry",
            "value": 6,
            "color": "hsl(96, 35%, 83%)"
        },
        {
            "id": "Hawthorn",
            "label": "Hawthorn",
            "value": 110,
            "color": "hsl(0, 74%, 79%)"
        },
        {
            "id": "Hazelnut",
            "label": "Hazelnut",
            "value": 7,
            "color": "hsl(0, 42%, 84%)"
        },
        {
            "id": "Hemlock",
            "label": "Hemlock",
            "value": 4,
            "color": "hsl(200, 43%, 79%)"
        },
        {
            "id": "Hibiscus",
            "label": "Hibiscus",
            "value": 13,
            "color": "hsl(330, 68%, 82%)"
        },
        {
            "id": "Holly",
            "label": "Holly",
            "value": 7,
            "color": "hsl(169, 29%, 77%)"
        },
        {
            "id": "Honey Locust",
            "label": "Honey Locust",
            "value": 44,
            "color": "hsl(51, 75%, 79%)"
        },
        {
            "id": "Hornbeam",
            "label": "Hornbeam",
            "value": 30,
            "color": "hsl(194, 77%, 82%)"
        },
        {
            "id": "Katsura Tree",
            "label": "Katsura Tree",
            "value": 91,
            "color": "hsl(273, 57%, 76%)"
        },
        {
            "id": "Kentucky Coffee Tree",
            "label": "Kentucky Coffee Tree",
            "value": 1,
            "color": "hsl(82, 38%, 74%)"
        },
        {
            "id": "Lilac",
            "label": "Lilac",
            "value": 57,
            "color": "hsl(278, 58%, 85%)"
        },
        {
            "id": "Linden",
            "label": "Linden",
            "value": 167,
            "color": "hsl(87, 71%, 82%)"
        },
        {
            "id": "Magnolia",
            "label": "Magnolia",
            "value": 102,
            "color": "hsl(89, 77%, 82%)"
        },
        {
            "id": "Maple",
            "label": "Maple",
            "value": 1232,
            "color": "hsl(97, 71%, 79%)"
        },
        {
            "id": "Oak",
            "label": "Oak",
            "value": 69,
            "color": "hsl(103, 53%, 80%)"
        },
        {
            "id": "Parrotia",
            "label": "Parrotia",
            "value": 24,
            "color": "hsl(0, 80%, 88%)"
        },
        {
            "id": "Pear",
            "label": "Pear",
            "value": 35,
            "color": "hsl(37, 80%, 80%)"
        },
        {
            "id": "Pine",
            "label": "Pine",
            "value": 20,
            "color": "hsl(93, 76%, 80%)"
        },
        {
            "id": "Plane Tree",
            "label": "Plane Tree",
            "value": 121,
            "color": "hsl(18, 25%, 77%)"
        },
        {
            "id": "Redbud",
            "label": "Redbud",
            "value": 28,
            "color": "hsl(327, 71%, 82%)"
        },
        {
            "id": "Rowan",
            "label": "Rowan",
            "value": 27,
            "color": "hsl(342, 68%, 87%)"
        },
        {
            "id": "Serviceberry",
            "label": "Serviceberry",
            "value": 25,
            "color": "hsl(129, 55%, 88%)"
        },
        {
            "id": "Spruce",
            "label": "Spruce",
            "value": 16,
            "color": "hsl(185, 69%, 87%)"
        },
        {
            "id": "Stewartia",
            "label": "Stewartia",
            "value": 19,
            "color": "hsl(284, 63%, 86%)"
        },
        {
            "id": "Strawberry Tree",
            "label": "Strawberry Tree",
            "value": 1,
            "color": "hsl(19, 71%, 82%)"
        },
        {
            "id": "Styrax",
            "label": "Styrax",
            "value": 79,
            "color": "hsl(199, 73%, 83%)"
        },
        {
            "id": "Sumac",
            "label": "Sumac",
            "value": 3,
            "color": "hsl(20, 79%, 83%)"
        },
        {
            "id": "Sweetgum",
            "label": "Sweetgum",
            "value": 75,
            "color": "hsl(72, 78%, 80%)"
        },
        {
            "id": "Tulip Tree",
            "label": "Tulip Tree",
            "value": 8,
            "color": "hsl(34, 44%, 80%)"
        },
        {
            "id": "Walnut",
            "label": "Walnut",
            "value": 15,
            "color": "hsl(75, 34%, 81%)"
        },
        {
            "id": "Yellowwood",
            "label": "Yellowwood",
            "value": 1,
            "color": "hsl(60, 56%, 76%)"
        },
        {
            "id": "Zelkova",
            "label": "Zelkova",
            "value": 5,
            "color": "hsl(94, 40%, 79%)"
        }
    ]
};

export default neighbourhoodData